"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextMessage = void 0;
const BaseMessage_1 = require("./BaseMessage");
const LocalizationContext_1 = require("../../context/LocalizationContext");
exports.ContextMessage = (0, LocalizationContext_1.withLocalization)(BaseMessage_1.BaseMessage);
//# sourceMappingURL=ContextMessage.js.map